import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { fetchDriverSelfRatingOptions } from '../../actions/form';

export default function FormContainer(WrappedForm, formType) {
  class WrappedFormContainer extends Component {
    componentWillMount() {
      this.props.fetchDriverSelfRatingOptions(formType);
    }

    render() {
      return (
        <WrappedForm {...this.props} />
      );
    }
  }

  const mapStateToProps = state => ({
    formType: _.get(state, 'ui.formType'),
  });

  return connect(
    mapStateToProps,
    { fetchDriverSelfRatingOptions },
  )(WrappedFormContainer);
}
